import React from 'react';
import { IconProps } from './model/IconInterface';

const CalendarIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <rect x='3' y='5' width='18' height='16' rx='2' />
        <line x1='16' y1='3' x2='16' y2='7' />
        <line x1='8' y1='3' x2='8' y2='7' />
        <line x1='3' y1='10' x2='21' y2='10' />
    </svg>
);

export default CalendarIcon;
